import Image1 from "../image/quad/Image1.webp";
import Image3 from "../image/quad/Image3.webp";
import Image4 from "../image/quad/Image4.webp";

export const QuadData = [
  {
    id: 1,
    image: Image1,
    alt: "Image quad 1",
  },
  {
    id: 2,
    image: Image3,
    alt: "Image quad 3",
  },
  {
    id: 3,
    image: Image4,
    alt: "Image quad 4",
  },
];
